/* centro-popup-suerte.js — Popup "PRUEBA TU SUERTE" (shampoo que cae entre clavijas → 10% en toda la tienda + alta en Klaviyo).
   v5.1 2026-10-01 (Héctor): el formulario ya NO dice que el premio llega al correo (frenaba el juego); texto persuasivo "Prueba tu suerte
   con este juego…". La pantalla GANASTE sí lo dice: "Tu premio ya te llegó al correo. Válido solo por hoy".
   v5 2026-09-30 (Héctor): 9 FILAS DE CLAVIJAS y ruta que toca las 9 (antes 7 filas y 6 toques con saltos largos: "salta de un punto a uno muy abajo").
   v4 2026-09-30 (Héctor) "v4-correo-primero": CORREO PRIMERO, JUEGO DESPUÉS, SIN CÓDIGO EN PANTALLA, FRECUENCIA COMO LA AGENCIA.
   (v2 2026-09-30: 6 casillas — 5% · envío gratis · sin premio · 10% toda la tienda (GANA SIEMPRE) · 3x2 anticaída · 10% bálsamo.)
   Centro · 2026-09-29. Se carga desde los 3 layouts del tema (theme, renova-blank, centro-home) → UNA sola lógica y UNA sola memoria
   para TODA la tienda. El snippet Liquid no lo carga a clientes con pedidos.

   FLUJO v4:
     1. Abre en cuanto la página está lista (PRIMERA = 0; espera máx. 1.2 s a las tipografías). Se ve el tablero con el título
        "PRUEBA TU SUERTE" y el formulario de correo ya visible ("Deja tu correo y tira el shampoo: el premio te llega al correo",
        correo, "QUIERO PROBAR SUERTE →", "Un tiro por persona · se suma a cualquier promo", "No, prefiero pagar completo").
        El botón de jugar NO existe hasta que el correo sea válido y se envíe.
     2. Al enviar: alta en Klaviyo (/client/subscriptions, lista KL, custom_source 'Popup Prueba tu suerte (10%)',
        properties {popup_suerte: 'REGALO10', popup_version: 'v4-correo-primero'}), form:true, se oculta el formulario y aparece
        "PROBAR SUERTE".
     3. Probar suerte → misma caída de siempre → cae en 10% EN TODA LA TIENDA → pantalla final SIN CÓDIGO:
        "🎉 GANASTE 10 % EN TODA LA TIENDA / Revisa tu correo: ahí te llegó tu regalo…" + "SEGUIR COMPRANDO →".
        El código (REGALO10) lo manda el correo 1 del flujo de Bienvenida de Klaviyo. Ya no se aplica /discount/ ni se decoran enlaces
        para altas nuevas; solo se respeta el `codigo` guardado por versiones anteriores (SUERTE30 hasta VENCE_SUERTE30).

   FRECUENCIA (Héctor 2026-09-30: "como la agencia"): sale en CADA sesión nueva (30 min de inactividad = sesión nueva), aunque la
   hayan cerrado con la X o con "No, prefiero pagar completo". Una sola vez por sesión en todas las páginas. NUNCA a quien dejó
   correo o compró. No sale en /cart, /checkout, /account, políticas ni páginas internas de Centro; si la pestaña está oculta espera.

   ESTADO en localStorage['rnvp2'] (misma llave de versiones anteriores: quien ya dejó su correo o compró no lo recibe):
     inicio   ts en que empezó la sesión
     ultimo   ts de la última actividad (carga de página, clic, scroll, tecla) → si pasan > SESION sin actividad, sesión nueva
     visto    ts en que se abrió el popup en esta sesión → no vuelve a salir en la sesión, en ninguna página
     cerro    ts en que lo cerró con la X / "No, prefiero…" en esta sesión (se borra al empezar sesión nueva)
     form     true si dejó su correo → NUNCA más
     compro   true si compró → NUNCA más
     codigo   SOLO versiones anteriores (REGALO10/SUERTE30): se sigue aplicando al ir a pagar. Las altas v4 no lo guardan.
     checkout_ts  ts del último clic a pagar (heurística de compra, ventana de 24 h)
   localStorage['rnv_anon'] = UUID anónimo del visitante (respaldo en cookie rnv_anon) para unir eventos en Klaviyo.
   Respaldo en cookie rnvs4 por si el navegador bloquea localStorage: 'v' = visto en esta sesión (30 min), 'f' = dejó correo (1 año).

   EVENTOS a Klaviyo (Client Events API, company_id RNsVAY, fire-and-forget, keepalive, nunca en modo TEST):
     "Popup Suerte · Mostrado"  al abrir            perfil {anonymous_id}
     "Popup Suerte · Correo"    alta enviada        perfil {email, anonymous_id}  → Klaviyo une el anónimo con el correo
     "Popup Suerte · Jugó"      al pulsar Probar    perfil {email, anonymous_id}
     properties: {version:'v4-correo-primero', pagina, dispositivo:'movil'|'escritorio'}
   Verificado 2026-09-30 desde terminal: el Client API acepta anonymous_id (202) y el evento aparece en /api/events con el perfil
   anónimo (métrica "Popup Suerte · Mostrado" = WKMas7).

   El premio NO se resalta antes de tiempo: la casilla ganadora solo se ilumina cuando el envase cae en ella. */
(function () {
  'use strict';
  if (window.__rnvs) return;
  window.__rnvs = true;

  var KC = 'RNsVAY', KL = 'Ws5gZT', KEY = 'rnvp2', CODIGO = 'REGALO10', PREMIO = '10%';
  var VENCE_SUERTE30 = Date.UTC(2026, 9, 2, 6, 0, 0);   // SUERTE30 (versión del 30 %) se respeta a quien ya lo ganó hasta el 1-oct 23:59 CDMX
  var VERSION = 'v8-1-vez-por-sesion';
  // ---------- FRECUENCIA (Héctor 2026-09-30, "como la agencia") ----------
  // v7 2026-10-06 (Héctor: "a los 5 segundos… si le da X que le vuelva a aparecer en menos tiempo… subir aún más las suscripciones"):
  //  · abre a los 5 s de entrar · si lo cierra con la X vuelve a salir a los 3 min si sigue navegando · máximo 3 veces por visita
  //  · visita nueva (30 min sin actividad) = vuelve a empezar · nunca a quien dejó su correo o compró
  var PRIMERA = 5000;              // ms después de entrar
  var REAPARECE = 3 * 60 * 1000;   // tras la X, vuelve a salir a los 3 minutos de seguir navegando
  var MAXVISITA = 1;               // v8 2026-10-11 (Héctor): UNA sola vez por sesión; tras la X no vuelve hasta una sesión nueva (30 min sin actividad)
  var SESION = 30 * 60 * 1000;     // 30 min sin actividad = sesión nueva → vuelve a salir aunque lo hayan cerrado
  var MINIMO = 1000;               // al volver a una pestaña que estaba oculta, espera 1 s
  var DIA = 24 * 60 * 60 * 1000;   // ventana de la heurística de compra (clic a pagar → carrito vacío)
  var TEST = window.__SUERTE_TEST || null;
  if (TEST && TEST.delay != null) { PRIMERA = TEST.delay; MINIMO = Math.min(MINIMO, TEST.delay); }

  // ---------- recursos ----------
  var yo = document.currentScript || document.querySelector('script[src*="centro-popup-suerte"]');
  var ENVASE = (TEST && TEST.envase) || (yo && yo.src ? yo.src.replace(/centro-popup-suerte(\.min)?\.js/, 'centro-suerte-envase.png') : '');

  // ---------- popups viejos: apagados en toda la tienda ----------
  try {
    var kill = document.createElement('style');
    kill.textContent = '#rnvp,#popSus,#rnvp.open,#popSus.open,#rnvp.on,#popSus.on{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important}';
    (document.head || document.documentElement).appendChild(kill);
    var quitar = function () { ['popSus', 'rnvp'].forEach(function (id) { var n = document.getElementById(id); if (n && n.parentNode) n.parentNode.removeChild(n); }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', quitar); else quitar();
    setTimeout(quitar, 1500); setTimeout(quitar, 7000);
  } catch (e) {}

  // ---------- estado ----------
  var memoria = {};
  function leer() {
    try { var s = JSON.parse(localStorage.getItem(KEY) || 'null'); if (s && typeof s === 'object') return s; } catch (e) {}
    return memoria;
  }
  function guardar(s) { memoria = s; try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
  function poner(c) { var s = leer(); for (var k in c) { if (c[k] === undefined) delete s[k]; else s[k] = c[k]; } guardar(s); return s; }
  function leerCookie(n) { var m = (document.cookie || '').match(new RegExp('(?:^|;\\s*)' + n + '=([^;]*)')); return m ? m[1] : ''; }
  function cookieVisto() { var c = leerCookie('rnvs4'); return c === 'v' || c === 'f'; }
  function marcarCookie(valor, segundos) {
    try { document.cookie = 'rnvs4=' + valor + '; path=/; SameSite=Lax; max-age=' + segundos; } catch (e) {}
  }

  var ahora = Date.now(), st = leer(), ult = st.ultimo || st.inicio, previa = !!st.inicio;
  if (!st.inicio || !ult || ahora - ult > SESION || ult > ahora) {
    // sesión nueva: vuelve a salir aunque lo hayan cerrado; se conservan form/compro/codigo/checkout_ts
    st = poner({ inicio: ahora, ultimo: ahora, visto: 0, cerro: undefined, cerrado: undefined, veces: 0 });
    if (previa && leerCookie('rnvs4') === 'v') marcarCookie('v', 1);  // la marca de la sesión anterior ya no cuenta (solo si localStorage sirve)
  } else {
    st = poner({ ultimo: ahora });
    if (st.visto && leerCookie('rnvs4') === 'v') marcarCookie('v', SESION / 1000);
  }
  // actividad (máx. 1 escritura por minuto) → la sesión sigue viva mientras navega o lee
  var ultEscr = ahora;
  function actividad() {
    var n = Date.now(); if (n - ultEscr < 60000) return; ultEscr = n;
    var s = leer(); if (s.ultimo && n - s.ultimo > SESION) return;    // ya venció: la siguiente página abre sesión nueva
    poner({ ultimo: n }); if (s.visto && leerCookie('rnvs4') === 'v') marcarCookie('v', SESION / 1000);
  }
  ['click', 'scroll', 'keydown', 'touchstart'].forEach(function (ev) { try { window.addEventListener(ev, actividad, { passive: true, capture: true }); } catch (e) {} });

  // ---------- código de VERSIONES ANTERIORES (v2/v3 guardaban `codigo`): se sigue aplicando al ir a pagar ----------
  // Las altas v4 NO guardan `codigo` → no se decoran enlaces ni se aplica /discount/: el código llega por correo.
  function conCodigo() {
    var s = leer(); if (!s.form || !s.codigo) return null;
    if (s.codigo === 'SUERTE30' && Date.now() > VENCE_SUERTE30) { poner({ codigo: undefined }); return null; }
    return s.codigo;
  }
  function decorar(a) {
    var c = conCodigo(); if (!c || !a || !a.getAttribute) return;
    var h = a.getAttribute('href') || '';
    if (!/\/cart\/\d+:\d+/.test(h) || /[?&]discount=/.test(h)) return;
    a.setAttribute('href', h + (h.indexOf('?') < 0 ? '?' : '&') + 'discount=' + encodeURIComponent(c));
  }

  // ---------- heurística de compra (igual que el popup anterior) ----------
  function marcarCheckout() { poner({ checkout_ts: Date.now() }); }
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var a = t.closest('[data-ccd-pagar],a[href*="/checkout"],button[name="checkout"],a[href*="/cart/"]');
    if (!a) return;
    if (a.getAttribute('aria-disabled') === 'true' || a.disabled) return;
    decorar(a);
    marcarCheckout();
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.getAttribute) return;
    if (/\/checkout/.test(f.getAttribute('action') || '')) marcarCheckout();
  }, true);
  if (!st.compro && st.checkout_ts && (ahora - st.checkout_ts) < DIA && !TEST) {
    try {
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (!c || typeof c.item_count !== 'number') return;
          if (c.item_count === 0) { poner({ compro: true, checkout_ts: undefined }); limpiarTimers(); cerrar(false); }
          else poner({ checkout_ts: undefined });
        }).catch(function () {});
    } catch (e) {}
  }

  // ---------- dónde NO sale: carrito, pago, cuenta, políticas y páginas internas de Centro ----------
  var NO = /^\/(cart|checkouts?|checkout|account|challenge|password|tools|apps|policies)(\/|$)|^\/pages\/[^\/]*(-centro-|centro-mando|tablero|plan-vivo|panel-|redes-)/i;
  var excluida = NO.test(location.pathname) && !TEST;

  var timers = [], ui = null;
  function limpiarTimers() { while (timers.length) clearTimeout(timers.pop()); }
  function bloqueado() {
    var s = leer();
    return !!(s.form || s.compro || leerCookie('rnvs4') === 'f' || (s.veces || 0) >= MAXVISITA);   // v7: la X ya no lo bloquea toda la visita
  }
  function yaSalio() { var s = leer(); if (s.inicio) return !!s.visto && !(s.cerro && s.cerro >= s.visto); return cookieVisto(); }   // v7: si lo cerró, puede reaparecer

  function programar() {
    limpiarTimers();
    if (excluida || bloqueado() || yaSalio()) return;
    var s = leer(), restante = s.cerro ? REAPARECE - (Date.now() - s.cerro) : PRIMERA - (Date.now() - s.inicio);
    var espera = restante > 0 ? restante : (s.cerro ? 1500 : PRIMERA);   // v7: 5 s al entrar; 3 min después de cerrarlo
    timers.push(setTimeout(abrir, espera));
  }

  // otra pestaña abrió/cerró el popup → esta ya no lo muestra
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    if (bloqueado() || yaSalio()) { limpiarTimers(); }
  });

  // =====================================================================================================
  //  JUEGO (canvas)
  // =====================================================================================================
  var W = 430, HC = 932, OY = 92, SH = 748;          // el escenario muestra y = 92 … 840 del lienzo lógico
  var GOLD = '#E8B54D', GOLD2 = '#F6D57A';
  var FT = '"Anton","Avenir Next Condensed",Impact,"Arial Narrow",sans-serif';
  var FB = '"Archivo","Avenir Next","Helvetica Neue",Arial,sans-serif';
  var T_DROP = 2.8, BTN = { x: 215, y: 757, w: 306, h: 54 };
  var BOARD = { top: 292, rowH: 34, rows: 9, cx: 215, gap: 56 };   // v5: 9 filas de clavijas (antes 7 de 46 px) → más rebotes, sin saltos largos
  var SLOT_Y = 640, SLOT_H = 76;
  var NS = 6, GS = 350 / NS, WIN = 3;                       // 6 casillas de 58.3 px; gana SIEMPRE la 3 (10% en toda la tienda)
  function cx(i) { return 40 + (i + .5) * GS; }             // centro de la casilla i
  function dv(k) { return 40 + k * GS; }                    // división k (0 y 6 son las paredes)
  var slots = [
    { t: '5%', s: ['DESCUENTO'] },
    { t: 'ENVÍO', s: ['GRATIS'] },
    { t: 'SIN', s: ['PREMIO'] },
    { t: '10%', s: ['EN TODA', 'LA TIENDA'] },
    { t: '3x2', s: ['ANTICAÍDA'] },
    { t: '10%', s: ['EN EL', 'BÁLSAMO'] }
  ];
  var pegs = [];
  (function () { for (var r = 0; r < BOARD.rows; r++) { var n = r % 2 ? 5 : 6; for (var i = 0; i < n; i++) pegs.push({ x: r % 2 ? dv(i + 1) : cx(i), y: BOARD.top + r * BOARD.rowH }); } })();
  // ruta determinista: roza la orilla de SIN PREMIO y siempre termina en la casilla 3 (10% en toda la tienda)
  var path = [
    { x: 215, y: 254, d: 0 },
    { x: cx(2), y: BOARD.top + 0 * BOARD.rowH, d: .30, hit: true },
    { x: dv(2), y: BOARD.top + 1 * BOARD.rowH, d: .24, hit: true },
    { x: cx(1), y: BOARD.top + 2 * BOARD.rowH, d: .24, hit: true },
    { x: dv(2), y: BOARD.top + 3 * BOARD.rowH, d: .24, hit: true },
    { x: cx(2), y: BOARD.top + 4 * BOARD.rowH, d: .24, hit: true },
    { x: dv(3), y: BOARD.top + 5 * BOARD.rowH, d: .24, hit: true },
    { x: cx(3), y: BOARD.top + 6 * BOARD.rowH, d: .24, hit: true },
    { x: dv(3), y: BOARD.top + 7 * BOARD.rowH, d: .24, hit: true },
    { x: cx(3), y: BOARD.top + 8 * BOARD.rowH, d: .24, hit: true },
    { x: dv(3) + 13, y: 668, d: .55, land: true },
    { x: cx(3), y: 668, d: .5 },
    { x: cx(3), y: 790, d: .45, sink: true }
  ];
  (function () { var acc = 0; for (var i = 0; i < path.length; i++) { path[i].t = acc; acc += i < path.length - 1 ? path[i + 1].d : 0; } })();
  var LAND_I = (function () { for (var i = 0; i < path.length; i++) if (path[i].land) return i; return path.length - 3; })();
  var T_LAND = T_DROP + path[LAND_I].t, T_REVEAL = T_LAND + 1.7;

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function ease(u) { return u < .5 ? 2 * u * u : 1 - Math.pow(-2 * u + 2, 2) / 2; }
  function easeOutBack(u) { var c = 1.70158; return 1 + (c + 1) * Math.pow(u - 1, 3) + c * Math.pow(u - 1, 2); }
  function easeOut(u) { return 1 - Math.pow(1 - u, 3); }
  function rnd(seed) { var s = seed * 9301 + 49297; return function () { s = (s * 9301 + 49297) % 233280; return s / 233280; }; }

  var confetti = (function () {
    var R = rnd(7), arr = [], cols = [GOLD, GOLD2, '#fff', '#fff', GOLD, '#c9962e'];
    for (var i = 0; i < 110; i++) {
      var ang = -Math.PI / 2 + (R() - .5) * 1.9, sp = 260 + R() * 380;
      arr.push({ vx: Math.cos(ang) * sp, vy: Math.sin(ang) * sp, w: 5 + R() * 7, h: 3 + R() * 5, rot: R() * 6, rv: (R() - .5) * 14, c: cols[Math.floor(R() * 6)], d: R() * .25 });
    }
    return arr;
  })();

  function crearJuego(cv) {
    var DPR = Math.min(window.devicePixelRatio || 1, 2.5);
    cv.width = Math.round(W * DPR); cv.height = Math.round(SH * DPR);
    var ctx = cv.getContext('2d');
    try { ctx.letterSpacing = '0px'; ctx.wordSpacing = '0px'; } catch (e) {}
    var env = new Image(); if (ENVASE) env.src = ENVASE;
    var AMB = 0, BK = 1, INTRO = true, TP = null, UNL = null;   // UNL: instante en que dejó su correo (antes no hay botón de jugar)

    function rr(x, y, w, h, r) { ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r); ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath(); }
    function fT(px) { ctx.font = '400 ' + px + 'px ' + FT; }
    function fB(px, w) { ctx.font = (w || '500') + ' ' + px + 'px ' + FB; }

    function bottle(t) {
      if (t < 0) { var k = BK; return { x: 215, y: 254 - (1 - easeOut(k)) * 70 + Math.sin(AMB * 6) * 2, a: Math.sin(AMB * 4) * .06, seg: -1, al: k }; }
      for (var i = 0; i < path.length - 1; i++) {
        var a = path[i], b = path[i + 1];
        if (t >= a.t && t < a.t + b.d) {
          var u = (t - a.t) / b.d, x, y, ang;
          if (b.land) { y = a.y + (b.y - a.y) * u * u; x = a.x + (b.x - a.x) * ease(u); ang = .35 - .55 * u; }
          else if (b.sink) { x = b.x; y = a.y + (b.y - a.y) * (u * u); ang = 0; }
          else if (i === path.length - 3) { x = a.x + (b.x - a.x) * easeOut(u); y = b.y; ang = Math.sin(u * Math.PI * 3) * .28 * (1 - u); }
          else {
            var hop = i === 0 ? 0 : 11;   // v5: filas más juntas → brinco más corto
            y = a.y + (b.y - a.y) * (u * u * .6 + u * .4) - hop * Math.sin(Math.PI * u);
            x = a.x + (b.x - a.x) * ease(u);
            ang = (i % 2 ? -1 : 1) * Math.sin(u * Math.PI) * .45 + (b.x - a.x) / 220;
          }
          return { x: x, y: y, a: ang, seg: i, u: u };
        }
      }
      var l = path[path.length - 1]; return { x: l.x, y: l.y, a: 0, seg: 99 };
    }
    function drawBottle(x, y, a, alpha, scale) {
      var base = ctx.globalAlpha;
      ctx.save(); ctx.globalAlpha = base * alpha; ctx.translate(x, y); ctx.rotate(a);
      ctx.shadowColor = 'rgba(232,181,77,.55)'; ctx.shadowBlur = 22;
      var h = 92 * scale;
      if (env.complete && env.naturalWidth) { var w = h * env.naturalWidth / env.naturalHeight; ctx.drawImage(env, -w / 2, -h / 2, w, h); }
      else { // respaldo si la imagen no cargó: envase dibujado
        var w2 = h * .42; rr(-w2 / 2, -h / 2 + h * .16, w2, h * .84, 7); ctx.fillStyle = '#111'; ctx.fill(); ctx.strokeStyle = GOLD; ctx.lineWidth = 1.2; ctx.stroke();
        ctx.fillStyle = '#222'; ctx.fillRect(-w2 * .22, -h / 2, w2 * .44, h * .18);
      }
      ctx.restore();
    }
    function drawConfetti(t, ox, oy) {
      var base = ctx.globalAlpha;
      for (var i = 0; i < confetti.length; i++) {
        var p = confetti[i], tt = t - p.d; if (tt < 0 || tt > 2.6) continue;
        var x = ox + p.vx * tt * (1 - tt * .18), y = oy + p.vy * tt + 520 * tt * tt, al = clamp(1 - (tt - 1.8) / .8, 0, 1);
        ctx.save(); ctx.globalAlpha = base * al; ctx.translate(x, y); ctx.rotate(p.rot + p.rv * tt); ctx.fillStyle = p.c;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, Math.abs(p.h * Math.cos(tt * 9 + p.rot))); ctx.restore();
      }
    }
    function drawSparks(t, x, y, seed) {
      var R = rnd(seed), base = ctx.globalAlpha;
      for (var i = 0; i < 10; i++) {
        var a = R() * Math.PI * 2, sp = 60 + R() * 110; if (t > .45) break;
        var px = x + Math.cos(a) * sp * t, py = y + Math.sin(a) * sp * t + 300 * t * t;
        ctx.save(); ctx.globalAlpha = base * (1 - t / .45); ctx.fillStyle = i % 3 ? GOLD2 : '#fff';
        ctx.beginPath(); ctx.arc(px, py, Math.max(.2, 2.2 - t * 3), 0, 7); ctx.fill(); ctx.restore();
      }
    }
    function drawBtn(G) {
      var A = AMB, base = ctx.globalAlpha;
      if (UNL == null) return;                                   // v4: sin correo no hay botón
      var al = clamp((A - Math.max(.9, UNL)) / .4, 0, 1); if (al <= 0) return;
      var fade = 1; if (G >= T_LAND) fade = 1 - clamp((G - T_LAND) / .3, 0, 1);
      var busy = !INTRO, kp = TP == null ? -9 : A - TP;
      if (fade > 0) {
        var sc = .9 + .1 * easeOutBack(al);
        if (!busy) sc *= 1 + .035 * Math.sin(A * 5.5);
        else if (kp < .2) sc *= .93 + .07 * (kp / .2);
        ctx.save(); ctx.globalAlpha = base * al * fade; ctx.translate(BTN.x, BTN.y); ctx.scale(sc, sc);
        var x0 = -BTN.w / 2, y0 = -BTN.h / 2;
        if (!busy) {
          ctx.save(); ctx.globalAlpha = base * al * (.35 + .25 * Math.sin(A * 5.5)); rr(x0 - 7, y0 - 7, BTN.w + 14, BTN.h + 14, 22); ctx.strokeStyle = GOLD2; ctx.lineWidth = 2; ctx.stroke(); ctx.restore();
          rr(x0, y0, BTN.w, BTN.h, 16); var bg = ctx.createLinearGradient(x0, 0, -x0, 0); bg.addColorStop(0, '#c9962e'); bg.addColorStop(.5, GOLD2); bg.addColorStop(1, '#c9962e');
          ctx.fillStyle = bg; ctx.shadowColor = 'rgba(232,181,77,.8)'; ctx.shadowBlur = 30; ctx.fill(); ctx.shadowBlur = 0;
          ctx.save(); rr(x0, y0, BTN.w, BTN.h, 16); ctx.clip(); var shx = ((A * 260) % 700) - 350; var sg = ctx.createLinearGradient(shx - 40, 0, shx + 40, 0);
          sg.addColorStop(0, 'rgba(255,255,255,0)'); sg.addColorStop(.5, 'rgba(255,255,255,.6)'); sg.addColorStop(1, 'rgba(255,255,255,0)'); ctx.fillStyle = sg; ctx.fillRect(x0, y0, BTN.w, BTN.h); ctx.restore();
          ctx.textAlign = 'center'; fB(22, '800'); ctx.fillStyle = '#000'; ctx.fillText('PROBAR SUERTE', 0, 8);
        } else {
          rr(x0, y0, BTN.w, BTN.h, 16); ctx.fillStyle = 'rgba(232,181,77,.10)'; ctx.fill(); ctx.strokeStyle = 'rgba(232,181,77,.5)'; ctx.lineWidth = 1.2; ctx.stroke();
          ctx.textAlign = 'center'; fB(15, '800'); ctx.fillStyle = GOLD2; ctx.fillText('TIRO EN CURSO' + new Array(2 + Math.floor(A * 3) % 3).join('.'), 0, 6);
        }
        ctx.restore();
      }
      if (kp >= 0 && kp < .6) { ctx.save(); ctx.globalAlpha = base * (1 - kp / .6) * .8; ctx.strokeStyle = GOLD2; ctx.lineWidth = 3; rr(BTN.x - BTN.w / 2 - kp * 60, BTN.y - BTN.h / 2 - kp * 40, BTN.w + kp * 120, BTN.h + kp * 80, 16 + kp * 40); ctx.stroke(); ctx.restore(); }
    }

    function core(T) {
      if (T <= 0) return;
      var tin = clamp(T / .55, 0, 1), i, k;
      var sx = 0, sy = 0; if (T > T_LAND) { k = T - T_LAND; var amp = 7 * Math.exp(-k * 7); sx = Math.sin(k * 95) * amp; sy = Math.cos(k * 80) * amp * .7; }
      ctx.save(); ctx.translate(W / 2 + sx, HC / 2 + sy); var sc = .78 + .22 * easeOutBack(tin); ctx.scale(sc, sc); ctx.translate(-W / 2, -HC / 2); ctx.globalAlpha = Math.min(1, tin * 1.6);
      var G0 = ctx.globalAlpha;
      var CX = 22, CY = 112, CW = 386, CH = 708;
      ctx.save(); ctx.shadowColor = 'rgba(232,181,77,.35)'; ctx.shadowBlur = 50; rr(CX, CY, CW, CH, 26); ctx.fillStyle = '#0B0B10'; ctx.fill(); ctx.restore();
      rr(CX, CY, CW, CH, 26); var cg = ctx.createLinearGradient(0, CY, 0, CY + CH); cg.addColorStop(0, '#17161d'); cg.addColorStop(.5, '#0b0b10'); cg.addColorStop(1, '#07070a'); ctx.fillStyle = cg; ctx.fill();
      ctx.save(); rr(CX, CY, CW, CH, 26); ctx.clip();
      ctx.save(); ctx.translate(215, 215); ctx.rotate(AMB * .35);
      for (i = 0; i < 12; i++) { ctx.rotate(Math.PI / 6); var rg = ctx.createLinearGradient(0, 0, 0, -420); rg.addColorStop(0, 'rgba(232,181,77,.16)'); rg.addColorStop(1, 'rgba(232,181,77,0)'); ctx.fillStyle = rg; ctx.beginPath(); ctx.moveTo(0, 0); ctx.lineTo(-26, -420); ctx.lineTo(26, -420); ctx.closePath(); ctx.fill(); }
      ctx.restore(); ctx.restore();
      rr(CX + .5, CY + .5, CW - 1, CH - 1, 26); ctx.strokeStyle = 'rgba(232,181,77,.7)'; ctx.lineWidth = 1.2; ctx.stroke();
      // cerrar ×
      ctx.strokeStyle = '#8a8a94'; ctx.lineWidth = 1.7; ctx.beginPath(); ctx.moveTo(378, 132); ctx.lineTo(392, 146); ctx.moveTo(392, 132); ctx.lineTo(378, 146); ctx.stroke();
      // marca + título
      var ttl = clamp((T - .35) / .5, 0, 1); ctx.save(); ctx.globalAlpha = G0 * ttl; ctx.translate(0, (1 - ttl) * -12);
      fB(12, '700'); ctx.fillStyle = GOLD; ctx.textAlign = 'center'; ctx.fillText('R E N O V A I N F I N I T Y', 215, 150);
      fT(43); var tg = ctx.createLinearGradient(0, 170, 0, 215); tg.addColorStop(0, '#fff'); tg.addColorStop(1, '#d8d8de'); ctx.fillStyle = tg; ctx.fillText('PRUEBA TU SUERTE', 215, 209);
      ctx.save(); ctx.globalAlpha = G0 * ttl * (1 - BK); fB(15, '500'); ctx.fillStyle = '#b8b8c2'; ctx.fillText('Suelta el shampoo y llévate un premio real', 215, 234); ctx.restore();
      ctx.restore();
      // tablero
      rr(40, 268, 350, 352, 18); ctx.fillStyle = 'rgba(255,255,255,.025)'; ctx.fill(); ctx.strokeStyle = 'rgba(255,255,255,.07)'; ctx.lineWidth = 1; ctx.stroke();
      var td = T - T_DROP, b = bottle(td), p, glow;
      for (var j = 0; j < pegs.length; j++) {
        p = pegs[j]; glow = 0;
        for (i = 1; i < path.length; i++) { if (path[i].hit && Math.abs(path[i].x - p.x) < 1 && Math.abs(path[i].y - p.y) < 1) { k = td - path[i].t; if (k >= 0) glow = Math.exp(-k * 5); } }
        ctx.save(); ctx.shadowColor = GOLD; ctx.shadowBlur = 6 + glow * 26; ctx.fillStyle = glow > .05 ? GOLD2 : '#5a5140'; ctx.beginPath(); ctx.arc(p.x, p.y, 4.2 + glow * 3.5, 0, 7); ctx.fill(); ctx.restore();
        if (glow > .05) { ctx.save(); ctx.globalAlpha = G0 * glow * .6; ctx.strokeStyle = GOLD2; ctx.lineWidth = 2; ctx.beginPath(); ctx.arc(p.x, p.y, 8 + (1 - glow) * 26, 0, 7); ctx.stroke(); ctx.restore(); }
      }
      for (i = 1; i < path.length; i++) { if (path[i].hit) { k = td - path[i].t; if (k >= 0 && k < .45) drawSparks(k, path[i].x, path[i].y, i * 13); } }
      // casillas: TODAS iguales hasta que el envase cae (el premio no se adelanta)
      var landed = T >= T_LAND;
      for (i = 0; i < slots.length; i++) {
        var s = slots[i], x = dv(i) + 3, w = GS - 6, win = landed && i === WIN, pulse = landed ? .5 + .5 * Math.sin((T - T_LAND) * 9) : 0;
        rr(x, SLOT_Y, w, SLOT_H, 10);
        if (win) { ctx.save(); ctx.shadowColor = GOLD; ctx.shadowBlur = 18 + pulse * 26; ctx.fillStyle = GOLD; ctx.fill(); ctx.restore(); ctx.fillStyle = '#000'; }
        else { ctx.fillStyle = landed ? 'rgba(255,255,255,.03)' : 'rgba(255,255,255,.06)'; ctx.fill(); ctx.strokeStyle = 'rgba(255,255,255,.14)'; ctx.lineWidth = 1; ctx.stroke(); ctx.fillStyle = landed ? '#4a4a52' : '#e9e9ee'; }
        ctx.textAlign = 'center'; fT(s.t.length > 3 ? 16 : 21); ctx.fillText(s.t, x + w / 2, SLOT_Y + (s.s.length > 1 ? 29 : 34));
        fB(7.6, '800'); for (var q = 0; q < s.s.length; q++) ctx.fillText(s.s[q], x + w / 2, SLOT_Y + (s.s.length > 1 ? 45 : 52) + q * 11);
      }
      ctx.strokeStyle = 'rgba(232,181,77,.35)'; ctx.lineWidth = 2; for (i = 1; i < NS; i++) { ctx.beginPath(); ctx.moveTo(dv(i), SLOT_Y - 30); ctx.lineTo(dv(i), SLOT_Y + SLOT_H); ctx.stroke(); }
      // cuenta regresiva 3-2-1
      if (T > 1.0 && T < T_DROP + .35) {
        var steps = [[1.0, '3'], [1.6, '2'], [2.2, '1'], [2.8, '¡YA!']];
        for (i = 0; i < steps.length; i++) { k = T - steps[i][0]; if (k >= 0 && k < .6) { var ss = 1 + k * 1.6; ctx.save(); ctx.globalAlpha = G0 * (1 - k / .6); ctx.translate(215, 430); ctx.scale(ss, ss); fT(72); ctx.fillStyle = GOLD2; ctx.shadowColor = GOLD; ctx.shadowBlur = 30; ctx.textAlign = 'center'; ctx.fillText(steps[i][1], 0, 26); ctx.restore(); } }
      }
      // envase con estela
      if (td > 0 && !landed) { for (var g = 3; g >= 1; g--) { var bb = bottle(td - g * .028); drawBottle(bb.x, bb.y, bb.a, .13 * (4 - g) / 3, 1); } }
      if (b.seg === -1) { drawBottle(b.x, b.y, b.a, b.al, 1); }
      else if (T < T_REVEAL + .4) { ctx.save(); if (b.seg >= path.length - 2) { rr(40, 268, 350, SLOT_Y + 3 - 268, 18); ctx.clip(); } drawBottle(b.x, b.y, b.a, 1, 1); ctx.restore(); }
      // destello + confeti al aterrizar
      if (landed) {
        k = T - T_LAND;
        if (k < .5) { ctx.save(); ctx.globalAlpha = G0 * (1 - k / .5) * .9; var fg = ctx.createRadialGradient(cx(WIN), SLOT_Y + 38, 0, cx(WIN), SLOT_Y + 38, 180); fg.addColorStop(0, 'rgba(255,240,200,1)'); fg.addColorStop(1, 'rgba(255,240,200,0)'); ctx.fillStyle = fg; ctx.fillRect(0, 0, W, HC); ctx.restore(); }
        drawConfetti(k, cx(WIN), SLOT_Y + 20);
        var lb = clamp((k - .6) / .4, 0, 1); ctx.save(); ctx.globalAlpha = G0 * lb; ctx.translate(215, 776); ctx.scale(.9 + .1 * easeOutBack(lb), .9 + .1 * easeOutBack(lb)); fT(27); ctx.fillStyle = GOLD2; ctx.shadowColor = GOLD; ctx.shadowBlur = 24; ctx.textAlign = 'center'; ctx.fillText('¡CAYÓ EN ' + PREMIO + ' DE DESCUENTO!', 0, 10); ctx.restore();
      } else if (UNL != null || !INTRO) {                          // v4: antes del correo, esa franja la ocupa el formulario
        fB(12, '500'); ctx.fillStyle = '#7d7d88'; ctx.textAlign = 'center';
        ctx.fillText(INTRO ? 'Toca el botón y suelta el shampoo · un tiro por persona' : 'Un tiro por persona · premio real en tu compra de hoy', 215, 811);
      }
      drawBtn(T);
      // ---------- tarjeta de premio (el formulario es HTML real, encima) ----------
      if (T >= T_REVEAL) {
        k = clamp((T - T_REVEAL) / .6, 0, 1); var yoff = (1 - easeOutBack(k)) * 520;
        ctx.save(); ctx.translate(0, yoff);
        rr(CX, CY, CW, CH, 26); var pg = ctx.createLinearGradient(0, CY, 0, CY + CH); pg.addColorStop(0, '#1a1710'); pg.addColorStop(.35, '#0c0c11'); pg.addColorStop(1, '#07070a'); ctx.fillStyle = pg; ctx.fill();
        rr(CX + .5, CY + .5, CW - 1, CH - 1, 26); ctx.strokeStyle = GOLD; ctx.lineWidth = 1.4; ctx.stroke();
        ctx.save(); rr(CX, CY, CW, CH, 26); ctx.clip(); ctx.translate(215, 300); ctx.rotate(AMB * .5);
        for (i = 0; i < 14; i++) { ctx.rotate(Math.PI / 7); var rg2 = ctx.createLinearGradient(0, 0, 0, -460); rg2.addColorStop(0, 'rgba(232,181,77,.22)'); rg2.addColorStop(1, 'rgba(232,181,77,0)'); ctx.fillStyle = rg2; ctx.beginPath(); ctx.moveTo(0, 0); ctx.lineTo(-22, -460); ctx.lineTo(22, -460); ctx.closePath(); ctx.fill(); }
        ctx.restore();
        ctx.strokeStyle = '#8a8a94'; ctx.lineWidth = 1.7; ctx.beginPath(); ctx.moveTo(378, 132); ctx.lineTo(392, 146); ctx.moveTo(392, 132); ctx.lineTo(378, 146); ctx.stroke();
        ctx.textAlign = 'center';
        fB(13, '700'); ctx.fillStyle = GOLD; ctx.fillText('T U   P R E M I O', 215, 160);
        fT(40); ctx.fillStyle = '#fff'; ctx.fillText('¡GANASTE!', 215, 207);
        var pop = 1 + .05 * Math.sin((T - T_REVEAL) * 5); ctx.save(); ctx.translate(205, 300); ctx.scale(pop, pop); fT(112);
        var gg = ctx.createLinearGradient(0, -90, 0, 20); gg.addColorStop(0, '#fff2c8'); gg.addColorStop(.5, GOLD2); gg.addColorStop(1, '#c9962e'); ctx.fillStyle = gg; ctx.shadowColor = 'rgba(232,181,77,.8)'; ctx.shadowBlur = 40; ctx.fillText(PREMIO, 0, 32); ctx.restore();
        fT(22); ctx.fillStyle = '#fff'; ctx.fillText('DE DESCUENTO EN TODA LA TIENDA', 215, 373);
        fB(14, '500'); ctx.fillStyle = '#b8b8c2'; ctx.fillText('Aplica a todos los productos · válido hoy', 215, 397);
        drawBottle(362, 298, .18, 1, .95);
        var left = Math.max(0, 15 * 60 - Math.floor(T - T_REVEAL)), mm = ('0' + Math.floor(left / 60)).slice(-2), sec = ('0' + (left % 60)).slice(-2);
        rr(108, 418, 214, 34, 17); ctx.fillStyle = 'rgba(232,181,77,.12)'; ctx.fill(); ctx.strokeStyle = 'rgba(232,181,77,.5)'; ctx.lineWidth = 1; ctx.stroke();
        fB(13, '700'); ctx.fillStyle = GOLD2; ctx.fillText('Tu premio expira en  ' + mm + ':' + sec, 215, 440);
        ctx.restore();
      }
      ctx.restore();
    }

    return {
      frame: function (T, tp, unl) {
        AMB = T; TP = tp; UNL = unl == null ? null : unl; BK = clamp((T - .6) / .45, 0, 1);
        var pressed = tp != null && T >= tp; INTRO = !pressed;
        ctx.setTransform(DPR, 0, 0, DPR, 0, 0); ctx.clearRect(0, 0, W, SH);
        try { ctx.letterSpacing = '0px'; } catch (e) {}
        ctx.save(); ctx.translate(0, -OY); core(pressed ? T - tp + .9 : Math.min(T, .9)); ctx.restore();
      }
    };
  }

  // =====================================================================================================
  //  EVENTOS A KLAVIYO (Client Events API · fire-and-forget: nunca bloquea la interfaz)
  // =====================================================================================================
  var correoVivo = '';                                      // correo de esta visita (solo en memoria, no se guarda)
  function uuid() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    var d = Date.now(); return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0; d = Math.floor(d / 16); return (c === 'x' ? r : (r & 3 | 8)).toString(16);
    });
  }
  function anonId() {
    var id = '';
    try { id = localStorage.getItem('rnv_anon') || ''; } catch (e) {}
    if (!id) id = decodeURIComponent(leerCookie('rnv_anon') || '');
    if (!/^[\w-]{8,64}$/.test(id)) id = uuid();
    try { localStorage.setItem('rnv_anon', id); } catch (e) {}
    try { document.cookie = 'rnv_anon=' + encodeURIComponent(id) + '; path=/; SameSite=Lax; max-age=' + (2 * 365 * 86400); } catch (e) {}
    return id;
  }
  function evento(nombre) {
    if (TEST) { (window.__rnvsEventos = window.__rnvsEventos || []).push({ nombre: nombre, email: correoVivo || null }); return; }
    try {
      var perfil = { anonymous_id: anonId() }; if (correoVivo) perfil.email = correoVivo;
      fetch('https://a.klaviyo.com/client/events/?company_id=' + KC, {
        method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'event', attributes: {
          metric: { data: { type: 'metric', attributes: { name: nombre } } },
          properties: { version: VERSION, pagina: location.pathname, dispositivo: (window.innerWidth < 768 ? 'movil' : 'escritorio') },
          profile: { data: { type: 'profile', attributes: perfil } } } } })
      }).catch(function () {});
    } catch (e) {}
  }

  // =====================================================================================================
  //  INTERFAZ
  // =====================================================================================================
  var CSS = ''
    + '#rnvs,#rnvs *{box-sizing:border-box;margin:0;padding:0;letter-spacing:0;text-transform:none;line-height:1.25;text-shadow:none;float:none;min-width:0;min-height:0}'
    + '#rnvs{position:fixed;inset:0;z-index:2147483600;display:flex;align-items:center;justify-content:center;overflow:hidden;opacity:0;transition:opacity .4s ease;font-family:' + FB + ';-webkit-tap-highlight-color:transparent;background:rgba(0,0,0,.78);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px)}'
    + '#rnvs.on{opacity:1}'
    + '#rnvs .rnvs-stage{position:relative;flex:none;width:430px;height:748px;transform-origin:center center}'
    + '#rnvs canvas{position:absolute;left:0;top:0;width:430px!important;height:748px!important;max-width:none;display:block;letter-spacing:0!important;word-spacing:0!important}'
    + '#rnvs button{font-family:inherit;border:0;background:none;cursor:pointer;-webkit-appearance:none;appearance:none;box-shadow:none;min-height:0;text-transform:none}'
    + '#rnvs .rnvs-x{position:absolute;left:362px;top:24px;width:46px;height:46px;border-radius:50%;z-index:5}'
    + '#rnvs .rnvs-play{position:absolute;left:54px;top:632px;width:322px;height:66px;border-radius:18px;z-index:4;display:none}'
    + '#rnvs .rnvs-play.on{display:block}'
    + '#rnvs .rnvs-form,#rnvs .rnvs-pie,#rnvs .rnvs-fin{position:absolute;left:48px;width:334px;z-index:4;text-align:center;opacity:0;transform:translateY(14px);transition:opacity .45s ease,transform .45s ease;pointer-events:none}'
    + '#rnvs .rnvs-form{top:226px;padding:14px 14px 15px;border-radius:18px;background:rgba(11,11,16,.9);border:1px solid rgba(232,181,77,.38);box-shadow:0 0 34px rgba(0,0,0,.6)}'
    + '#rnvs .rnvs-pie{top:634px}'
    + '#rnvs .rnvs-fin{top:372px}'
    + '#rnvs .rnvs-form.on,#rnvs .rnvs-pie.on,#rnvs .rnvs-fin.on{opacity:1;transform:none;pointer-events:auto}'
    + '#rnvs .rnvs-form.fuera,#rnvs .rnvs-pie.fuera{opacity:0;transform:translateY(-10px);pointer-events:none}'
    + '#rnvs p{color:inherit}#rnvs .rnvs-l{font-size:13px;font-weight:500;color:#d5d5dc;margin-bottom:11px}'
    + '#rnvs input{display:block;width:100%;height:52px;min-height:0;box-shadow:none;margin:0;border-radius:14px;border:1.3px solid rgba(232,181,77,.55);background:#15151b;color:#fff;font-family:inherit;font-size:16px;font-weight:500;padding:0 18px;outline:none;-webkit-appearance:none;appearance:none}'
    + '#rnvs input:focus{border-color:' + GOLD + ';box-shadow:0 0 0 3px rgba(232,181,77,.18)}'
    + '#rnvs input::placeholder{color:#6f6f7a}'
    + '#rnvs .rnvs-go{position:relative;overflow:hidden;display:block;width:100%;height:54px;margin-top:13px;border-radius:14px;background:linear-gradient(90deg,#c9962e,' + GOLD2 + ',#c9962e);color:#000;font-size:18px;font-weight:800;letter-spacing:.2px;box-shadow:0 0 26px rgba(232,181,77,.55);animation:rnvsp 1.1s ease-in-out infinite;text-decoration:none;line-height:54px}'
    + '#rnvs .rnvs-go::after{content:"";position:absolute;top:0;bottom:0;width:80px;left:-100px;background:linear-gradient(90deg,transparent,rgba(255,255,255,.55),transparent);animation:rnvss 2.4s linear infinite}'
    + '@keyframes rnvsp{50%{transform:scale(1.025)}}@keyframes rnvss{to{left:120%}}'
    + '#rnvs .rnvs-s{font-size:12px;color:#8a8a94;margin-top:12px}'
    + '#rnvs .rnvs-err{font-size:12px;color:#ff8a7a;margin-top:8px;min-height:0}'
    + '#rnvs .rnvs-ps{margin-top:14px;border-radius:14px;background:rgba(255,255,255,.04);padding:12px 10px 13px}'
    + '#rnvs .rnvs-ps b{display:block;font-size:13px;font-weight:700;color:' + GOLD + '}'
    + '#rnvs .rnvs-ps span{display:block;font-size:12px;color:#b8b8c2;margin-top:5px}'
    + '#rnvs .rnvs-no{display:inline-block;margin-top:4px;font-size:12px;color:#77778a;text-decoration:underline;padding:8px 10px}'
    + '#rnvs .rnvs-pie .rnvs-s{margin-top:0}'
    + '#rnvs .rnvs-fin .rnvs-gan{font-family:' + FT + ';font-size:25px;line-height:1.15;color:' + GOLD2 + ';margin-bottom:10px}'
    + '#rnvs .rnvs-ok{font-size:12px;font-weight:700;letter-spacing:.22em!important;color:' + GOLD + '}'
    + '#rnvs .rnvs-t{font-size:13.5px;line-height:1.45;color:#d5d5dc}'
    + 'html.rnvs-lock,html.rnvs-lock body{overflow:hidden!important}';

  function montar() {
    var st1 = document.createElement('style'); st1.id = 'rnvs-css'; st1.textContent = CSS; document.head.appendChild(st1);
    if (!document.querySelector('link[href*="family=Anton"]')) {
      var lk = document.createElement('link'); lk.rel = 'stylesheet';
      lk.href = 'https://fonts.googleapis.com/css2?family=Anton&family=Archivo:wght@500;700;800&display=swap'; document.head.appendChild(lk);
    }
    var root = document.createElement('div'); root.id = 'rnvs';
    root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.setAttribute('aria-label', 'Prueba tu suerte');
    root.innerHTML = '<div class="rnvs-stage">'
      + '<canvas aria-hidden="true"></canvas>'
      + '<button type="button" class="rnvs-x" aria-label="Cerrar"></button>'
      + '<button type="button" class="rnvs-play" aria-label="Probar suerte"></button>'
      + '<div class="rnvs-form">'
      +   '<form novalidate><p class="rnvs-l">Prueba tu suerte con este juego: suelta el shampoo y gana un premio real para tu compra de hoy</p>'
      +   '<input type="email" name="email" inputmode="email" autocomplete="email" placeholder="tu@correo.com" aria-label="Tu correo">'
      +   '<p class="rnvs-err" role="alert"></p>'
      +   '<button type="submit" class="rnvs-go">QUIERO PROBAR SUERTE  →</button></form>'
      + '</div>'
      + '<div class="rnvs-pie">'
      +   '<p class="rnvs-s">Un tiro por persona · se suma a cualquier promo</p>'
      +   '<button type="button" class="rnvs-no">No, prefiero pagar completo</button>'
      + '</div>'
      + '<div class="rnvs-fin" aria-hidden="true">'
      +   '<p class="rnvs-gan">🎉 GANASTE ' + PREMIO.replace('%', ' %') + ' EN TODA LA TIENDA</p>'
      +   '<p class="rnvs-t">Tu premio ya te llegó al correo.<br><strong>Válido solo por hoy</strong>: úsalo en tu compra.</p>'
      +   '<button type="button" class="rnvs-go" style="margin-top:16px">SEGUIR COMPRANDO  →</button>'
      +   '<p class="rnvs-s">Si no lo ves, búscalo en Promociones o Spam</p>'
      + '</div></div>';
    document.body.appendChild(root);
    return root;
  }

  function abrir() {
    if (ui || excluida || bloqueado() || yaSalio()) return;
    if (document.visibilityState === 'hidden') {          // pestaña en segundo plano: espera a que vuelva
      var alVolver = function () { if (document.visibilityState !== 'hidden') { document.removeEventListener('visibilitychange', alVolver); timers.push(setTimeout(abrir, MINIMO)); } };
      document.addEventListener('visibilitychange', alVolver); return;
    }
    poner({ visto: Date.now(), ultimo: Date.now(), veces: (leer().veces || 0) + 1 }); marcarCookie('v', SESION / 1000);   // ya no sale en ninguna otra página de la sesión
    var root = montar(), stage = root.querySelector('.rnvs-stage'), cv = root.querySelector('canvas');
    var bx = root.querySelector('.rnvs-x'), bp = root.querySelector('.rnvs-play'), fm = root.querySelector('.rnvs-form');
    var pie = root.querySelector('.rnvs-pie'), fin = root.querySelector('.rnvs-fin');
    var juego = crearJuego(cv), t0 = null, pressAt = null, unlAt = null, raf = 0, vivo = true, finOn = false;
    evento('Popup Suerte · Mostrado');
    ui = { root: root };

    function ajustar() {
      var vw = window.innerWidth, vh = window.innerHeight;
      var s = Math.min(vw / 430, (vh - 8) / 748, 1.12);
      stage.style.transform = 'scale(' + s.toFixed(4) + ')';
    }
    ajustar(); window.addEventListener('resize', ajustar);
    ui.ajustar = ajustar;

    function loop(now) {
      if (!vivo) return;
      if (t0 == null) t0 = now;
      var T = (now - t0) / 1000;
      juego.frame(T, pressAt, unlAt);
      if (!finOn && pressAt != null && T >= pressAt + (T_REVEAL - .9) + .55) {   // pantalla final: SIN código
        finOn = true; fin.classList.add('on'); fin.setAttribute('aria-hidden', 'false');
      }
      raf = requestAnimationFrame(loop);
    }
    function arrancar() {
      document.documentElement.classList.add('rnvs-lock');
      root.classList.add('on');
      fm.classList.add('on'); pie.classList.add('on');      // v4: el formulario ya está visible al abrir
      raf = requestAnimationFrame(loop);
    }
    // espera (máx. 1.2 s) a que carguen las tipografías para que el título no "salte"
    var listo = false, go = function () { if (listo) return; listo = true; arrancar(); };
    try {
      if (document.fonts && document.fonts.load) {
        Promise.all([document.fonts.load('400 43px Anton'), document.fonts.load('800 22px Archivo')]).then(go, go);
        setTimeout(go, 1200);
      } else go();
    } catch (e) { go(); }

    bp.addEventListener('click', function () {
      if (pressAt != null || unlAt == null || t0 == null) return;           // sin correo no se juega
      var T = (performance.now() - t0) / 1000; if (T < Math.max(1.0, unlAt + .3)) return;
      pressAt = T; bp.classList.remove('on');
      evento('Popup Suerte · Jugó');
    });
    bx.addEventListener('click', function () { cerrar(true); });
    pie.querySelector('.rnvs-no').addEventListener('click', function () { cerrar(true); });
    fin.querySelector('.rnvs-go').addEventListener('click', function () { cerrar(false); });
    var alEsc = function (e) { if (e.key === 'Escape') cerrar(true); };
    document.addEventListener('keydown', alEsc);

    var form = fm.querySelector('form'), mailEl = form.querySelector('input'), err = form.querySelector('.rnvs-err');
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var mail = (mailEl.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail)) { err.textContent = 'Revisa tu correo: parece incompleto.'; mailEl.focus(); return; }
      err.textContent = '';
      if (unlAt != null) return;                                                    // ya se envió
      poner({ form: true }); marcarCookie('f', 365 * 86400); limpiarTimers();       // dejó su correo: nunca más (v4 NO guarda `codigo`)
      correoVivo = mail;
      if (!TEST) {
        try {
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KC, {
            method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
            body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Popup Prueba tu suerte (10%)', profile: { data: { type: 'profile', attributes: { email: mail, properties: { popup_suerte: CODIGO, popup_version: VERSION } } } } }, relationships: { list: { data: { type: 'list', id: KL } } } } })
          }).catch(function () {});
        } catch (e) {}
      }
      evento('Popup Suerte · Correo');
      try { mailEl.blur(); } catch (e) {}
      fm.classList.add('fuera'); pie.classList.add('fuera');                       // se va el formulario…
      setTimeout(function () { fm.style.display = 'none'; pie.style.display = 'none'; }, 460);
      unlAt = t0 == null ? 0 : (performance.now() - t0) / 1000;                     // …y aparece PROBAR SUERTE
      bp.classList.add('on');
    });

    ui.cerrar = function () {
      vivo = false; cancelAnimationFrame(raf);
      window.removeEventListener('resize', ajustar);
      document.removeEventListener('keydown', alEsc);
      document.documentElement.classList.remove('rnvs-lock');
      root.classList.remove('on');
      setTimeout(function () { if (root.parentNode) root.parentNode.removeChild(root); }, 420);
    };
  }

  function cerrar(porUsuario) {
    if (!ui) return;
    if (porUsuario && !leer().form) poner({ cerro: Date.now() });   // v7: X → vuelve a salir a los 3 min (máx. 3 veces por visita)
    var u = ui; ui = null; u.cerrar();
    limpiarTimers();
    if (porUsuario) programar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', programar);
  else programar();

  if (TEST) window.__rnvsApi = { abrir: abrir, cerrar: cerrar, leer: leer, T_REVEAL: T_REVEAL, T_LAND: T_LAND, version: VERSION };
})();
